/** Refer to breakpoints in tailwind.config.js */

export const isMobileView = () => window.innerWidth <= 767;

export const isTabletView = () => window.innerWidth >= 768 && window.innerWidth <= 1023;
